<template>
  <div id="add-event-image" class="professional-popup">
    <v-card class="professional-document-card" elevation="24">
      <!-- Professional Header -->
      <div class="professional-header">
        <div class="header-content">
          <div class="header-icon">
            <v-icon size="28" color="white">mdi-file-document-plus</v-icon>
          </div>
          <div class="header-text">
            <h2 class="header-title">{{ pageTitle }}</h2>
            <p class="header-subtitle">
              Upload supporting documents for nomination
            </p>
          </div>
        </div>
        <v-btn icon large color="white" @click="closePrompt" class="close-btn">
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Professional Content Area -->
      <v-sheet
        id="scrolling-techniques-7"
        class="professional-content overflow-y-auto"
        max-height="600"
      >
        <v-container class="pa-6">
          <!-- Instructions Card -->
          <v-card class="instruction-card mb-6" outlined>
            <v-card-text class="pa-4">
              <div class="instruction-header">
                <v-icon color="info" class="mr-2">mdi-information</v-icon>
                <span class="instruction-title"
                  >Document Upload Guidelines</span
                >
              </div>
              <ul class="instruction-list mt-3">
                <li>Select appropriate document type from the dropdown</li>
                <li>Only PDF files are accepted for upload</li>
                <li>Add optional description to help identify the document</li>
                <li>Ensure document is clear and readable</li>
              </ul>
            </v-card-text>
          </v-card>

          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="submitData"
          >
            <!-- Document Upload Form -->
            <v-card class="upload-form-card" elevation="8">
              <v-card-text class="pa-6">
                <div class="form-section-title mb-4">
                  <v-icon color="primary" class="mr-2">mdi-file-upload</v-icon>
                  <span>Document Information</span>
                </div>

                <v-row wrap class="professional-form-row">
                  <!-- Document Type -->
                  <v-col cols="12" sm="6" md="4" lg="4">
                    <div class="form-field">
                      <label class="field-label">
                        <span class="required-asterisk">*</span>
                        Document Type
                      </label>
                      <v-select
                        :reduce="(option) => option.value"
                        :loading="DocumentTypeOptionsLoading"
                        :items="DocumentTypeOptions"
                        :rules="DocumentTypeRules"
                        v-model="DocumentType"
                        required
                        outlined
                        dense
                        class="professional-select"
                        placeholder="Select document type"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon color="primary" small
                            >mdi-file-document</v-icon
                          >
                        </template>
                      </v-select>
                    </div>
                  </v-col>

                  <!-- Description -->
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    v-if="DocumentType != ''"
                  >
                    <div class="form-field">
                      <label class="field-label">
                        Description
                        <span class="optional-text">(optional)</span>
                      </label>
                      <v-text-field
                        v-model="EventDescription"
                        :rules="EventDescriptionRules"
                        placeholder="Enter document description"
                        hint="Brief description of the document"
                        outlined
                        dense
                        class="professional-input"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon color="primary" small>mdi-text</v-icon>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>

                  <!-- PDF Upload -->
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                    lg="4"
                    v-if="DocumentType != ''"
                  >
                    <div class="form-field">
                      <label class="field-label">
                        <span class="required-asterisk">*</span>
                        Upload PDF Document
                      </label>
                      <v-file-input
                        :clearable="false"
                        truncate-length="25"
                        accept="application/pdf"
                        placeholder="Select PDF file to upload"
                        prepend-icon="mdi-file-pdf-box"
                        v-model="UploadPdf1"
                        @change="addPdf(1)"
                        outlined
                        dense
                        class="professional-file-input"
                        hint="Only PDF files are accepted"
                      >
                        <template v-slot:append-outer>
                          <v-btn
                            icon
                            small
                            color="error"
                            @click="deletePdf(1)"
                            class="delete-file-btn"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                      </v-file-input>
                    </div>
                  </v-col>
                </v-row>

                <!-- Action Buttons -->
                <v-row wrap v-if="DocumentType != ''" class="mt-4">
                  <v-col cols="12" class="text-center">
                    <div class="action-buttons">
                      <v-btn
                        :disabled="!valid1"
                        @click.prevent="submitData"
                        :loading="SubmitFlag"
                        elevation="8"
                        color="success"
                        class="professional-btn primary-btn mr-4 px-8"
                        large
                      >
                        <v-icon left>mdi-plus</v-icon>
                        Add Document
                      </v-btn>
                      <v-btn
                        @click="closePrompt"
                        elevation="4"
                        outlined
                        color="error"
                        class="professional-btn secondary-btn px-8"
                        large
                      >
                        <v-icon left>mdi-close</v-icon>
                        Cancel
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
        </v-container>
      </v-sheet>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,

      LoadingFlag: false,
      SubmitFlag: false,

      ActionDate: "",
      // ActionDate: LuxonDateTime.local().plus({days: 0}).toISO(),
      ActionDateRules: [(v) => !!v || "From date is required"],
      DateModal1: false,

      ActionDateMin: "",
      ActionDateMax: "",

      DocumentTypeRules: [(v) => !!v || "Document Type is required"],
      DocumentType: "",
      DocumentTypeOptions: [],
      DocumentTypeOptionsLoading: false,

      EventDescription: "",
      EventDescriptionRules: [],

      UploadPdf1: {},
      MemberImage: { src: null },

      StencilSize: { width: 1360, height: 768 },
    };
  },
  computed: {},
  watch: {
    DocumentTypeOptions: function () {
      console.log("watch DocumentTypeOptions");
      this.LoadingFlag = false;
      this.DocumentTypeOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt(document = {}) {
      console.log("closePrompt called");
      this.$emit("hideAddDocumentRecordPrompt", document);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getDocumentTypeOptions();
    },
    addPdf(id) {
      console.log("addPdf called");
      console.log({ id });
      this.addImage(id);
    },
    deletePdf(id) {
      console.log("deletePdf called");
      console.log({ id });
      this.deleteImage(id);
    },
    addImage(id) {
      console.log("addImage called");
      console.log({ id });
      switch (id) {
        case 1:
          var file = this.UploadPdf1;
          console.log({ file });
          var src = URL.createObjectURL(file);
          console.log({ src });
          if (this.MemberImage.src) {
            URL.revokeObjectURL(this.MemberImage.src);
          }
          var FileType = file.type;
          console.log({ FileType });
          this.MemberImage = {
            ImageName: file.name,
            ImageType: FileType,
            ImageUrl: src,
            UploadedImage: file,
          };
          break;

        default:
          break;
      }
    },
    deleteImage(id) {
      console.log("deleteImage called");
      console.log({ id });
      switch (id) {
        case 1:
          this.MemberImage = {
            ImageName: null,
            ImageType: null,
            ImageUrl: null,
            UploadedImage: null,
          };
          this.UploadPdf1 = {};
          break;

        default:
          break;
      }
    },
    getDocumentTypeOptions() {
      console.log("getDocumentTypeOptions called");
      this.DocumentTypeOptionsLoading = true;
      var selectbox1_source = "DocumentType";
      var selectbox1_destination = "DocumentTypeOptions";
      var selectbox1_url = "api/sub-category/options";
      var selectbox1_conditions_array = {
        UserInterface: 3,
        CategoryMainName: "nomination_document",
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    submitData() {
      console.log("submitData is called");
      let message = "";
      const validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        const DocumentType = this.DocumentType;
        const index1 = this.DocumentTypeOptions.map((e) => e.value).indexOf(
          DocumentType
        );
        const DocumentTypeName = this.DocumentTypeOptions[index1]?.text || "";

        const file = this.UploadPdf1;
        if (!file) {
          this.toast("error", "Please upload a PDF file.", true);
          return;
        }

        const FileType = file.type;
        const FileName = file.name;
        console.log({
          FileName,
        });
        const tempData = {
          EventDocumentId: null,
          DocumentFlag: true,
          DocumentTypeId: DocumentType,
          DocumentTypeName: DocumentTypeName,
          DocumentDescription:
            this.EventDescription || DocumentTypeName || "Supporting Document",
          FileType: FileType,
          UploadedFileName: FileName,
          UploadedFile: file,
          DocumentUrl: URL.createObjectURL(file),
          action: "",
        };

        console.log({ tempData });
        this.closePrompt(tempData);
      } else {
        message += "Kindly fill the required fields. ";
        this.toast("error", message, true);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#add-event-image {
  .mycard-text1 {
    font-family: sans-serif;
  }
  .fsize-4 {
    font-size: 18px !important;
  }
  .notes-text1 {
    padding: 5px;
    margin-left: 2rem;
    font-size: 14px;
    font-family: sans-serif;
  }

  // Professional Document Upload Popup Styles
  &.professional-popup {
    .professional-document-card {
      border-radius: 16px !important;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
      overflow: hidden;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;

      .professional-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 24px 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.05)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.05)"/><circle cx="25" cy="75" r="1" fill="rgba(255,255,255,0.03)"/><circle cx="75" cy="25" r="1" fill="rgba(255,255,255,0.03)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
          opacity: 0.3;
          pointer-events: none;
        }

        .header-content {
          display: flex;
          align-items: center;
          z-index: 1;
          position: relative;

          .header-icon {
            width: 56px;
            height: 56px;
            background: rgba(255, 255, 255, 0.15);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.1);
          }

          .header-text {
            .header-title {
              font-size: 24px;
              font-weight: 600;
              margin: 0;
              line-height: 1.2;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }

            .header-subtitle {
              font-size: 14px;
              opacity: 0.9;
              margin: 4px 0 0 0;
              font-weight: 300;
            }
          }
        }

        .close-btn {
          z-index: 1;
          position: relative;
          background: rgba(255, 255, 255, 0.1) !important;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.2) !important;
            transform: scale(1.05);
          }
        }
      }

      .professional-content {
        background: linear-gradient(to bottom, #f8fafc 0%, #e2e8f0 100%);

        .instruction-card {
          background: linear-gradient(
            135deg,
            #e3f2fd 0%,
            #bbdefb 100%
          ) !important;
          border: 1px solid #2196f3 !important;
          border-radius: 12px !important;
          box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15) !important;

          .instruction-header {
            display: flex;
            align-items: center;
            font-weight: 600;
            color: #1565c0;
            font-size: 16px;
          }

          .instruction-list {
            margin: 0;
            padding-left: 20px;
            color: #1976d2;

            li {
              margin-bottom: 8px;
              font-size: 14px;
              line-height: 1.4;
            }
          }
        }

        .upload-form-card {
          background: white !important;
          border-radius: 16px !important;
          border: 1px solid #e2e8f0;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;

          .form-section-title {
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 600;
            color: #334155;
            padding-bottom: 16px;
            border-bottom: 2px solid #f1f5f9;
          }

          .professional-form-row {
            .form-field {
              margin-bottom: 24px;

              .field-label {
                display: block;
                font-size: 14px;
                font-weight: 600;
                color: #374151;
                margin-bottom: 8px;

                .required-asterisk {
                  color: #ef4444;
                  font-weight: 700;
                  margin-right: 4px;
                }

                .optional-text {
                  color: #6b7280;
                  font-weight: 400;
                  font-size: 12px;
                  margin-left: 4px;
                }
              }

              .professional-select,
              .professional-input,
              .professional-file-input {
                .v-input__control {
                  .v-input__slot {
                    border-radius: 12px !important;
                    border: 2px solid #e5e7eb !important;
                    transition: all 0.3s ease;

                    &:hover {
                      border-color: #d1d5db !important;
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                    }

                    &.v-input--is-focused {
                      border-color: #3b82f6 !important;
                      box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
                    }
                  }
                }
              }

              .delete-file-btn {
                background: rgba(239, 68, 68, 0.1) !important;
                border: 1px solid rgba(239, 68, 68, 0.2);
                transition: all 0.3s ease;

                &:hover {
                  background: rgba(239, 68, 68, 0.2) !important;
                  transform: scale(1.1);
                }
              }
            }
          }

          .action-buttons {
            display: flex;
            justify-content: center;
            gap: 16px;
            margin-top: 32px;
            padding-top: 24px;
            border-top: 1px solid #f1f5f9;

            .professional-btn {
              border-radius: 12px !important;
              font-weight: 600 !important;
              text-transform: none !important;
              font-size: 16px !important;
              transition: all 0.3s ease !important;

              &.primary-btn {
                background: linear-gradient(
                  135deg,
                  #10b981 0%,
                  #059669 100%
                ) !important;
                color: white !important;
                box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3) !important;

                &:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 12px 32px rgba(16, 185, 129, 0.4) !important;
                }

                &:disabled {
                  background: linear-gradient(
                    135deg,
                    #9ca3af 0%,
                    #6b7280 100%
                  ) !important;
                  box-shadow: none !important;
                  transform: none !important;
                }
              }

              &.secondary-btn {
                border: 2px solid #ef4444 !important;
                color: #ef4444 !important;
                background: transparent !important;

                &:hover {
                  background: #ef4444 !important;
                  color: white !important;
                  transform: translateY(-2px);
                  box-shadow: 0 8px 24px rgba(239, 68, 68, 0.3) !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

// Responsive Design
@media (max-width: 768px) {
  #add-event-image.professional-popup {
    .professional-document-card {
      margin: 16px;

      .professional-header {
        padding: 20px 24px;

        .header-content {
          .header-icon {
            width: 48px;
            height: 48px;
            margin-right: 16px;
          }

          .header-text {
            .header-title {
              font-size: 20px;
            }

            .header-subtitle {
              font-size: 13px;
            }
          }
        }
      }

      .professional-content {
        .upload-form-card {
          .action-buttons {
            flex-direction: column;
            align-items: center;

            .professional-btn {
              width: 100%;
              max-width: 280px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  #add-event-image.professional-popup {
    .professional-document-card {
      margin: 8px;

      .professional-header {
        padding: 16px 20px;

        .header-content {
          .header-icon {
            width: 40px;
            height: 40px;
            margin-right: 12px;
          }

          .header-text {
            .header-title {
              font-size: 18px;
            }

            .header-subtitle {
              font-size: 12px;
            }
          }
        }
      }

      .professional-content {
        .instruction-card {
          .instruction-list {
            padding-left: 16px;
          }
        }
      }
    }
  }
}
</style>